module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/116-curacao-3a40b228209336821b87b91317705340.svg";